import { render, staticRenderFns } from "./my-switch.vue?vue&type=template&id=2fe76b06"
import script from "./my-switch.vue?vue&type=script&lang=js"
export * from "./my-switch.vue?vue&type=script&lang=js"
import style0 from "./my-switch.vue?vue&type=style&index=0&id=2fe76b06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Input: require('/app/components/ui/input/index.js').default})
